import React, {Component} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {connect} from "react-redux";
import './App.scss';
import '../node_modules/ol/ol.css'
import './asset/style/ol.css';
import Morpheus from './view/morpheus';
import LoginView from './view/loginview';
import {LoginRoute, PrivateRoute} from './helper/private.route';
import {authenticationStatus, openInNewTabType, viewerType} from './utils/const'
import "./asset/style/morpheus.css"
import "./asset/style/color.css";

import StageCleaner from './view/stagecleanerview';
import ObjectiveCleaner from './view/objectivecleanerview';
import Videos from './view/videosview';
import VideoViewer from './view/videoviewer';
import VignetteDiagnostics from './view/vignettediagnostics';
import CustomContext from './view/customcontext';
import {markCaseRead} from './redux_actions/cases.action';
import ManualMode from "./view/manualmode";
import GammaScan from "./view/gammaScan";
import LiveMode from "./view/livemodenew";
import BloodViewerSelector from "./view/bloodViewerSelector"
import MainThresh from "./view/highPowerThresh";
import C240Settings from "./view/c240/c240_settings";
import C240StageCleanUp from "./view/c240/c240_stage_cleanup";
import {store} from "./helper/store";
import cookie from "react-cookies";
import {login, logout, updateAuthStatus} from "./redux_actions/login.action";
import {isTrue, notNull} from "./utils/utils";
import {message, Spin} from 'antd';
import totpview from 'view/totpview';
import recoverytotpview from 'view/recoverytotpview';
import UpdatePassword from "./view/update_password";
import ScannerSettings from "./component/scanner/scanner_settings";
import './App.less'
import ConnectionStatus from "./ConnectionStatus";
import ChatWidget from "./component/chatroom/ChatWidget";
import {aclPermissions, hasPermissions} from "./const/ACLPermissions";
class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        }
    }

    componentDidMount = () => {
        this.verifyAuthentication().then((status) => {
            if (isTrue(status)) {
                this.props.dispatch(updateAuthStatus(authenticationStatus.AUTHENTICATED))
            } else {
                this.props.dispatch(updateAuthStatus(authenticationStatus.UNAUTHENTICATED))
            }
        })
        // Get Local IP address
    fetch("https://api.ipify.org?format=json")
        .then(res => res.json())
        .then(data => {
            this.setState({ ip_address: data.ip });
        })
        .catch(err => {
            console.error("Failed to fetch IP address", err);
        });

    }

    linkViewerNewTab = (id, type, displayOrder, specimen_type, viewer_type) => {
        let url = '';
        if (type === openInNewTabType.CASE) {
            url = `/case/${id}`;
            this.props.dispatch(markCaseRead({id: id}, false));
        } else if (type === openInNewTabType.SLIDE) {
            if ((specimen_type === "blood" || specimen_type === "bone_marrow") && (viewer_type !== viewerType.TISSUE)) {
                url = `/blood/${id}`;
            } else {
                url = `/gamma/${id}`;
            }
        }
        window.open(url, "_blank");
    };

    verifyAuthentication = () => {
        return new Promise((resolve, reject) => {

            const url = window.location.href.split('?')[1];
            let token = '';
            if (url) {
                let partsOfUrl = url.split('&');
                partsOfUrl.forEach((part) => {
                    const key = part.split('=')[0];
                    const value = part.split('=')[1];
                    if (key === 'token') {
                        token = value;
                    }
                });
            }

            if (token !== '') {
                // store.dispatch(logout())
                store.dispatch(login({
                    "username": "dummy",
                    "password": "dummy",
                    "authToken": token
                }, true)).then((response) => {
                    if (response.status === 200) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                }).catch(() => {
                    resolve(false);
                })
            } else {
                if (store.getState().loginAlerts.status === true || cookie.loadAll().token !== undefined) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            }
        });
    }

    render() {

        let menu = [{"label": "Open in a new tab", "callback": this.linkViewerNewTab}];
        let status = this.props.authStat;
        const username = cookie.load('username');
        const user_id = cookie.load('user_id');
        // Derive context from pathname, removing base URL and ensuring trailing slash
        const pathname = window.location.href.replace(window.location.origin + '/', '') || 'default';

        const context = `${pathname}`;
        const ip_address = this.state.ip_address;
        // console.log("Data from App.js for Chat", context,status,username, ip_address);

        if (this.state.loading) {
            return <Spin spinning={true}/>
        }

        return (
            <div className="App">
                <ConnectionStatus/>
                <Switch>
                    <LoginRoute exact path="/login" component={LoginView}/>
                    <LoginRoute exact path="/totp" component={totpview}/>
                    <LoginRoute exact path="/recovery_totp" component={recoverytotpview}/>
                    <PrivateRoute path={"/change_password/"} component={UpdatePassword} status={status}/>
                    <PrivateRoute path={"/blood/:id/"} component={BloodViewerSelector} status={status}/>
                    <PrivateRoute path={"/gamma/:id/"} component={GammaScan} status={status}/>
                    <PrivateRoute path={"/manualmode/:id/"} component={ManualMode} status={status}/>
                    <PrivateRoute path={"/stagecleaner/:id/"} component={StageCleaner} status={status}/>
                    <PrivateRoute path={"/objectivecleaner/:id/"} component={ObjectiveCleaner} status={status}/>
                    <PrivateRoute path={"/videos/:id/"} component={Videos} status={status}/>
                    <PrivateRoute path={"/video/:id/"} component={VideoViewer} status={status}/>
                    <PrivateRoute path={"/vignette_diagnostics/:id/"} component={VignetteDiagnostics}
                                  status={status}/>
                    <PrivateRoute path={"/main_thresh/:id/"} component={MainThresh} status={status}/>
                    <PrivateRoute path={"/livemode/:id/"} component={LiveMode} status={status}/>
                    <PrivateRoute path={"/scanner_settings/:id/"} component={ScannerSettings} status={status}/>
                    <PrivateRoute path={"/c240_settings/:id/"} component={C240Settings} status={status}/>
                    <PrivateRoute path={"/c240_stage_cleanup/:id/"} component={C240StageCleanUp} status={status}/>
                    <Route path={"/viewer/:id/"} render={(props) =>
                        <Redirect to={`/neo/${props.match.params.id}${props.location.search}`}/>}/>
                    <Route path={"/blood-viewer/:id/"} render={(props) =>
                        <Redirect to={`/blood/${props.match.params.id}${props.location.search}`}/>}/>
                    <Route path={"/gamma-viewer/:id/"} render={(props) =>
                        <Redirect to={`/gamma/${props.match.params.id}${props.location.search}`}/>}/>
                    <PrivateRoute path={"/"} component={Morpheus} status={status}/>
                </Switch>
                <CustomContext
                    items={menu}
                    visible={this.props.popupProps.visible}
                    x={this.props.popupProps.x}
                    y={this.props.popupProps.y}
                    record={this.props.popupProps.record}
                    height={this.props.popupProps.height}
                />
                {hasPermissions([aclPermissions.common_chat_room]) && status === authenticationStatus.AUTHENTICATED && username && (
                    <ChatWidget user_id={user_id} context={context} ip_address={ip_address} username={username} />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        popupProps: state.contextMenuReducer.popupProps,
        allCases: state.contextMenuReducer.popupProps,
        allSlides: state.contextMenuReducer.popupProps,
        authStat: state.loginAlerts.authVerificationStatus,
        username: state.loginAlerts.username,
        user_id: state.loginAlerts.user_id,

    };
};

export default connect(mapStateToProps)(App);
